export default __webpack_public_path__ + "static/media/2029.d26e9f11.png";